import { __awaiter, __rest } from "tslib";
import { createElement, useRef, useState } from 'rax';
import { renderToRoot } from '../utils/render';
import Dialog from './dialog';
import { isFunction, isPromise } from '../utils';
const DialogWrapper = (props) => {
    const { onClose, onOk } = props, others = __rest(props, ["onClose", "onOk"]);
    const dialogRef = useRef(null);
    const [visible, setVisible] = useState(true);
    const [loading, setLoading] = useState(false);
    const handleClose = (reason, e) => {
        if (dialogRef === null || dialogRef === void 0 ? void 0 : dialogRef.current) {
            setVisible(false);
        }
        if (onClose) {
            onClose(reason, e);
        }
    };
    const handleOk = (e) => __awaiter(void 0, void 0, void 0, function* () {
        if (isFunction(onOk)) {
            const res = onOk(e);
            if (isPromise(res)) {
                setLoading(true);
                res.finally(() => {
                    setLoading(false);
                    handleClose('ok', e);
                });
            }
            else {
                handleClose('ok', e);
            }
        }
        else {
            handleClose('ok', e);
        }
    });
    return (<Dialog ref={dialogRef} closeMode={['cancel', 'mask']} onOk={handleOk} onClose={handleClose} okProps={{
            loading,
        }} visible={visible} disablePortal {...others}/>);
};
const hideStack = [];
const methodFactory = (type) => (props) => {
    return show(Object.assign(Object.assign({}, props), { type }));
};
export const show = (props) => {
    const emptyFn = () => { };
    const { onClose = emptyFn } = props, others = __rest(props, ["onClose"]);
    const hideCurrent = renderToRoot(<DialogWrapper onClose={onClose} {...others}/>);
    hideStack.push(hideCurrent);
    return {
        hide: hideCurrent,
    };
};
export const hide = () => {
    while (hideStack.length) {
        const h = hideStack.pop();
        if (h) {
            h.call(null);
        }
    }
};
export const alert = methodFactory('alert');
export const confirm = methodFactory('confirm');
export const success = methodFactory('success');
export const error = methodFactory('error');
export const notice = methodFactory('notice');
export const warning = methodFactory('warning');
export const help = methodFactory('help');
